import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Radio } from 'antd';
import UIValue from './uiValue';
import UIValidation from './uiValidation';
function UIRadioComponent(props) {
    const [currentValue, setCurrentValue] = useState(props.selectedValue);
    useEffect(() => {
        setCurrentValue(props.selectedValue);
    }, [props.selectedValue]);
    const handleRadioChange = useCallback((e) => {
        const newValue = e.target.value;
        setCurrentValue(newValue);
        props.onChange(newValue);
    }, [props.onChange]);
    const radioValues = props.options.map((o) => _jsx(Radio, { value: o.replace(" ", ""), children: o }));
    return (_jsxs("div", { style: { display: 'flex', marginBottom: '16px' }, children: [props.title && _jsx("label", { style: { marginRight: '16px', fontWeight: 'bold', whiteSpace: 'nowrap', width: '120px', textAlign: 'left' }, children: props.title }), _jsx(Radio.Group, { value: currentValue, onChange: handleRadioChange, children: radioValues })] }));
}
export default class UIRadio extends UIValue {
    title;
    options;
    onChange;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        this.options = [];
        if ('options' in s && s.options) {
            for (const o of s.options) {
                this.options.push(o);
            }
        }
    }
    handleSelectionChange = (value) => {
        this.error = undefined;
        this.value = value;
        this.onChange?.(value);
    };
    getComponent() {
        const props = {
            title: this.title,
            selectedValue: this.value,
            options: this.options,
            onChange: this.handleSelectionChange,
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(UIRadioComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiRadio.js.map